import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Tabs, Tab, Typography, Box } from "@material-ui/core";
import style from './style'
const useStyles = makeStyles(style);

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index } = props;
  return (
    <div className={classes.tabpanel} role="tabpanel" id={`vertical-tabpanel-${index}`}>
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

export default function VerticalTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container disableGutters>
      <div className={classes.root}>
        <div>
          <Tabs
          data-aos="fade-in"
            orientation="vertical"
            value={value}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            color="primary"
            TabIndicatorProps={{ className: classes.tabIndicator }}

          >

            {
              props.data.map((data) => {
                return (
                  <Tab className="hover-detect" label={data.company} classes={{ root: classes.tab, wrapper: classes.tabWrapper }} />
                )
              })
            }
            <div className={classes.inactiveBorder}></div>

          </Tabs>
        </div>

        <div>

          {
            props.data.map((data, key) => {
              return (
                <TabPanel data-aos="fade-in" value={value} index={key} className={classes.tabpanel}>
                  <Typography data-aos="fade-in" variant="h5" gutterBottom style={{ display: 'flex' }}>
                    {data.role} @<a className="hover-detect" href={data.link} target="_blank" rel="noreferrer"><Typography variant="h5" gutterBottom style={{ color: '#5D5FFF' }}>{data.company}</Typography></a>
                  </Typography>
                  <Typography data-aos="fade-in" variant="h6" gutterBottom>
                    {data.period}
                  </Typography>
                  <Typography data-aos="fade-in" variant="subtitle1" gutterBottom>
                    {
                      data.content.map((d) => {
                        return (
                          <ul className="listItem">
                            <li className="listItem" data-aos="fade-in">{d}</li>
                          </ul>
                        )
                      })
                    }
                  </Typography>
                </TabPanel>
              )
            })
          }

        </div>
      </div>
    </Container>
  );
}